<nav id="report-header-title" class="nav-main flex-row">
  <div class="flex-1 flex-row">
    <button (click)="burgerOpen = !burgerOpen" class="flex-1 burger" [ngClass]="{ open: burgerOpen }">
      <fa-icon icon="bars"></fa-icon>
    </button>
  </div>
  <div class="flex-9 title">{{ report?.responsible?.orgDescription }} - {{ report?.responsible?.orgCode }}</div>

  <div id="report-header-percentage" class="info">
    <p class="percentage">{{ report?.doc | percent }}</p>
  </div>
</nav>
